import { render, staticRenderFns } from "./tutor_type_form.vue?vue&type=template&id=7bfbb762&"
import script from "./tutor_type_form.vue?vue&type=script&lang=js&"
export * from "./tutor_type_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports